import { ChipsInput } from '@prismamedia/one-components';
import { FC } from 'react';
import {
  BrandKey,
  TagOrderingInput,
  TagType,
} from '../../../../../../__generated__/queries-web';
import {
  useArticleTagsGetter,
  useGetTags,
} from '../../../../../../apollo/queries/tags.web.graphql';

interface TagsSelectProps {
  brandKey: BrandKey;
  disabled?: boolean;
  label: string;
  onChange: (tags: string[]) => void;
  value?: string[];
}

export const TagsSelect: FC<TagsSelectProps> = ({
  value: id_in = [],
  onChange,
  brandKey,
  disabled = false,
  ...rest
}) => {
  const searchTags = useArticleTagsGetter();

  const { data } = useGetTags({ where: { id_in }, first: 100 });
  const value = data?.tags.map(({ id, title }) => ({ id, label: title }));

  const fetchList = (search: string) =>
    searchTags({
      first: 1000,
      where: {
        title_contains: search || undefined,
        type_in: [
          TagType.Person,
          TagType.Tag,
          ...([BrandKey.TEL, BrandKey.TLS].includes(brandKey)
            ? [TagType.TvCollection]
            : []),
        ],
      },
      orderBy: [TagOrderingInput.title_ASC],
    }).then((tags) =>
      tags.map((tag) => ({
        id: tag.id,
        label: tag.title,
        secondaryLabel: tag.type,
      })),
    );

  return (
    <ChipsInput
      autocomplete={{ fetchList, mandatoryInput: true }}
      onChange={(items) => onChange(items.map(({ id }) => id))}
      value={value}
      disabled={disabled}
      {...rest}
    />
  );
};
